import { PlaceOrderAPI } from '../../apis/placeOrder/PlaceOrderAPI';

export const PlaceOrderService = {
  getByCode: async (placeOrderCode: string) => {
    return await PlaceOrderAPI.getByCode(placeOrderCode);
  },
  approve: async (placeOrderCode: string) => {
    return await PlaceOrderAPI.approve(placeOrderCode);
  },
  reject: async (placeOrderCode: string) => {
    return await PlaceOrderAPI.reject(placeOrderCode);
  },
  getPendingCount: async () => {
    return await PlaceOrderAPI.getPendingCount();
  },
  getPendingList: async () => {
    return await PlaceOrderAPI.getPendingList();
  },
};
